import { z } from 'zod';
import { ShareAuditEvents } from '@/types/events';

const auditBaseSchema = z.object({
  id: z.string(),
  timestamp: z.string(),
  user: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional(),
  objectType: z.string(),
  objectId: z.string(),
});

const shareAuditSchema = auditBaseSchema.extend({
  event: z.enum(ShareAuditEvents),
  details: z
    .object({
      collaborationEnabled: z.boolean().nullable().optional(),
    })
    .nullable()
    .optional(),
});

const genericAuditSchema = auditBaseSchema.extend({
  event: z.string(),
  // When the backend returns no details (empty array) it takes the form of an array instead of an object, throwing a zod error. We should make sure the
  // type of details is always the same from the backend when we handle the audit retractor.
  details: z
    .union([z.looseObject({}), z.array(z.unknown())])
    .nullable()
    .optional(),
});

export const auditSchema = z.union([shareAuditSchema, genericAuditSchema]);
export type Audit = z.infer<typeof auditSchema>;

export const getAuditsSchema = z.object({
  audit: z.array(auditSchema),
  pagination: z
    .object({
      offset: z.number(),
      limit: z.number(),
      count: z.number(),
    })
    .optional(),
});

export type GetAudits = z.infer<typeof getAuditsSchema>;
